import React from 'react';
import { useSelector } from 'react-redux';

import { DurationTicker } from 'components/DurationTicker';
import { getCurrentCycleStart } from 'lib/selectors/getCurrentCycleStart';
import { getArePartCountBucketsLoading } from 'lib/selectors/getPartCountBuckets';
import { LoadingStatTabSecondaryLabel } from 'pages/Machine/styled';
import {
  DURATION_FORMAT,
  DURATION_OPTIONS,
} from 'pages/Machine/Tabs/constants';

export const CyclesTimeCounter = () => {
  const currentCycleStart = useSelector(getCurrentCycleStart);
  const arePartCountBucketsLoading = useSelector(getArePartCountBucketsLoading);

  return arePartCountBucketsLoading ? (
    <LoadingStatTabSecondaryLabel />
  ) : currentCycleStart ? (
    <DurationTicker
      startDate={currentCycleStart.toDate()}
      format={DURATION_FORMAT}
      formatOptions={DURATION_OPTIONS}
    />
  ) : (
    '-'
  );
};
